// Core
import { ReactNode, useRef } from 'react';
// Packages
import cn from 'classnames';
// Components
import { MainContent } from 'components/lib';
import { useIsRailVisible } from 'components/SideRail';
// Custom Hooks
import { useBreakpoint } from 'customHooks';
import useScheduleWebSocket from 'customHooks/useScheduleWebSocket';
import { usePageEnterAnimation } from './usePageEnterAnimation';
// Interface and types
import { IGetUserRes } from 'types/userTypes';
// Styles
import styles from './content.module.scss';

interface IProps {
  children: ReactNode;
  isAuth?: boolean;
  user: IGetUserRes | null;
}

const Content = ({ children, isAuth, user }: IProps) => {
  const contentRef = useRef<HTMLElement>(null);
  const { xl } = useBreakpoint();
  const isRailVisible = useIsRailVisible(isAuth);
  useScheduleWebSocket({ user, isAuth });
  usePageEnterAnimation(contentRef);

  const containerAuthStyle = cn(xl ? styles.contentContainer : styles.wrap, {
    [styles.withRail]: isRailVisible,
  });
  const container = `${styles.container}`;

  return (
    <MainContent ref={contentRef} className={isAuth ? containerAuthStyle : container}>
      {children}
    </MainContent>
  );
};

export default Content;
